import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { ButtonBase, styled, Typography } from '@mui/material'
import {
  DARSNAMEH_CONFIG,
  FORM_CONFIG,
  POLL_CONFIG,
  UNIT_TEST_CONFIG,
} from '$common/wapp-bar-theme'
import { WappIcon } from '$comp/chat-list-tool-box/components/shared/wapp-icon'
import {
  openDarsnamehCreator,
  openFormCreator,
  openPollCreator,
  openUnitTestCreator,
} from '$logic/wapps/business'
import { CommonOnboarding } from '$logic/onboarding/types'
import { WithOnboarding } from '$common/tour'
import { showChatListToolboxModal } from '$comp/modals/chat-list-toolbox'

export const otherWappsConfig = [
  {
    ...POLL_CONFIG,
    onClick: openPollCreator,
    logoGradient: 'linear-gradient(180deg, #FFF35F 0%, #FFB100 100%)',
    key: 'POLL',
    onboarding: CommonOnboarding.POLL,
    hasFeatureOnboarding: true,
  },
  {
    ...FORM_CONFIG,
    onClick: openFormCreator,
    logoGradient: 'linear-gradient(180deg, #1DCBB0 0%, #008D77 100%)',
    key: 'FORM',
  },
  {
    ...FORM_CONFIG,
    onClick: openFormCreator,
    key: 'FORM',
    logoGradient: 'linear-gradient(180deg, #1DCBB0 0%, #008D77 100%)',
    onboarding: undefined,
    hasFeatureOnboarding: false,
  },
  {
    ...UNIT_TEST_CONFIG,
    onClick: openUnitTestCreator,
    key: 'UNIT_TEST',
    logoGradient: 'linear-gradient(180deg, #00BAFF 0%, #093DEB 100%)',
    onboarding: CommonOnboarding.UNIT_TEST,
    hasFeatureOnboarding: true,
  },
  {
    ...DARSNAMEH_CONFIG,
    onClick: openDarsnamehCreator,
    key: 'DARSNAMEH',
    logoGradient: 'linear-gradient(180deg, #3444FF 0%, #0E1781 100%)',
    hasFeatureOnboarding: false,
    onboarding: undefined,
  },
]

export function OtherWapps() {
  return (
    <>
      {otherWappsConfig.map(wappConfig =>
        wappConfig.onboarding ? (
          <WithOnboarding
            sx={{ gridColumn: 'span 1', width: '100%' }}
            key={wappConfig.key}
            onboarding={wappConfig.onboarding}
            hasFeatureOnboarding={wappConfig.hasFeatureOnboarding}
            onClick={async () => {
              await closeCurrentModal()
              wappConfig.onClick()
            }}
            hotspotPosition={{
              top: '0px',
              left: '22px',
            }}
            hotspotSize="small"
            openCurrentModal={showChatListToolboxModal}
          >
            <ListItemContainer>
              <WappIcon
                background={wappConfig.logoGradient}
                icon={wappConfig.icon}
              />
              <Typography variant="subtitle4" color="neutral800">
                {wappConfig.name}
              </Typography>
            </ListItemContainer>
          </WithOnboarding>
        ) : (
          <ListItemContainer
            key={wappConfig.key}
            onClick={async () => {
              await closeCurrentModal()
              wappConfig.onClick()
            }}
          >
            <WappIcon
              background={wappConfig.logoGradient}
              icon={wappConfig.icon}
            />
            <Typography variant="subtitle4" color="neutral800">
              {wappConfig.name}
            </Typography>
          </ListItemContainer>
        ),
      )}
    </>
  )
}

const ListItemContainer = styled(ButtonBase)`
  width: 100%;
  height: 92px;
  border-radius: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral100};
  }
  padding-top: 8px;
`
